// Suited for ACF posts

var GenericList = Vue.component('generic-list', {
	props: ['items', 'title'],
	template: `
		<div class="group" v-if="items">
			<h2 v-if="title">{{ title }}</h2>
			<transition-group name="fade" tag="ul" class="generic-list">
				<li v-for="item in items" :key="item.ID">
					<colored-link :type="item.post_type" :data-id="item.ID" :href="item.link">{{ item.post_title }}</colored-link>
				</li>
			</transition-group>
		</div>`
})

export default GenericList
